export default "__VITE_ASSET__84ecde2c__"